<iframe [src]="url"></iframe>
<app-vt-ui></app-vt-ui>